import { z } from '@harvestiq/zod';

export const sendLrpCombinedCampaignEmailsMessageSchema = z.object({
  orgId: z.string(),
  userId: z.string().uuid(),
  campaignIds: z.string().uuid().array().min(1),
  personalCampaignMessage: z.string().optional(),
  salesEffectiveDate: z.string().optional(), // This should be used only for manual queuing scripts. Do not actively use it.
});

export type SendLrpCombinedCampaignEmailsMessage = z.infer<
  typeof sendLrpCombinedCampaignEmailsMessageSchema
>;
